import { ActionTypes } from '../../constants/ActionTypes';
import {
  IEmployeePositionFastSignature,
  IFastSign,
} from '../../interfaces/FastSign';

export const onFastSign = (action: IFastSign) => {
  return {
    type: ActionTypes.FAST_SIGN,
    payload: action,
  };
};

export const onFastSignSUCCESS = () => {
  return {
    type: ActionTypes.FAST_SIGN_SUCCESS,
  };
};

export const onGetFastSign = (data: any) => {
  return {
    type: ActionTypes.GET_FAST_SING,
    payload: data,
  };
};

export const onGetFastSignSuccess = (
  fastSignatures: IEmployeePositionFastSignature[],
) => {
  return {
    type: ActionTypes.GET_FAST_SING_SUCCESS,
    payload: fastSignatures,
  };
};
